
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/do-not-sell",
      function () {
        return require("private-next-pages/do-not-sell.js");
      }
    ]);
  